const categoryMap = {
  'Handle:cstm:533': ['Color & Material', 'Liner'],
  'Handle:cstm:535': ['Color & Material', 'Liner'],
  'Handle:cstm:550': ['Color & Material', 'Liner'],
  'Handle:cstm:555': ['Color & Material', 'Liner'],
  'Handle:cstm:940': ['Color & Material', 'Liner'],
  'Handle:cstm:945': ['Color & Material', 'Liner'],
  'Handle:cstm:4010': ['Color & Material', 'Bolster', 'Pivot Ring'],
  'Handle:cstm:4050': ['Color & Material', 'Bolster', 'Pivot Ring'],
  'Handle:cstm:4055': ['Color & Material', 'Bolster', 'Pivot Ring'],
  'Handle:cstm:4000': ['Color & Material', 'Bolster', 'Pivot Ring'],
  'Handle:cstm:4060': ['Color & Material'],
  'Handle:cstm:4001': ['Color & Material'],
  'Handle:cstm:15085': ['Color & Material', 'Liner', 'Bolster'],
  'Handle:cstm:15080': ['Color & Material', 'Liner', 'Bolster'],
  'Handle:cstm:personalization': null,
  'Handle:cstm:service': null,
  'Blade:cstm:533': ['Artwork', 'Text', 'Shape', 'Steel', 'Finish'],
  'Blade:cstm:535': ['Artwork', 'Text', 'Shape', 'Steel', 'Finish'],
  'Blade:cstm:550': ['Artwork', 'Text', 'Shape', 'Steel', 'Finish'],
  'Blade:cstm:555': ['Artwork', 'Text', 'Shape', 'Steel', 'Finish'],
  'Blade:cstm:940': ['Artwork', 'Text', 'Steel', 'Finish'],
  'Blade:cstm:945': ['Artwork', 'Text', 'Steel', 'Finish'],
  'Blade:cstm:4010': ['Artwork', 'Text', 'Steel & Finish'],
  'Blade:cstm:4050': ['Artwork', 'Text', 'Steel & Finish'],
  'Blade:cstm:4055': ['Artwork', 'Text', 'Steel & Finish'],
  'Blade:cstm:4060': ['Artwork', 'Text', 'Steel & Finish'],
  'Blade:cstm:4001': ['Artwork', 'Text', 'Steel & Finish'],
  'Blade:cstm:4000': ['Artwork', 'Text', 'Steel & Finish'],
  'Blade:cstm:personalization': ['Text', 'Image'],
  'Blade:cstm:service': ['Text', 'Image'],
  'Blade:cstm:15085': ['Artwork', 'Text', 'Steel', 'Finish'],
  'Blade:cstm:15080': ['Artwork', 'Text', 'Steel', 'Finish'],
  'Hardware:cstm:533': ['Spacers & Thumb Lug', 'Clip', 'Screws', 'Axis'],
  'Hardware:cstm:535': ['Spacers & Thumb Lug', 'Clip', 'Screws', 'Axis'],
  'Hardware:cstm:550': ['Spacers & Thumb Lug', 'Clip', 'Screws', 'Axis'],
  'Hardware:cstm:555': ['Spacers & Thumb Lug', 'Clip', 'Screws', 'Axis'],
  'Hardware:cstm:940': ['Spacers & Thumb Lug', 'Clip', 'Screws', 'Axis'],
  'Hardware:cstm:945': ['Spacers & Thumb Lug', 'Clip', 'Screws', 'Axis'],
  'Hardware:cstm:4010': null,
  'Hardware:cstm:4050': null,
  'Hardware:cstm:4055': null,
  'Hardware:cstm:4060': null,
  'Hardware:cstm:4001': null,
  'Hardware:cstm:4000': null,
  'Hardware:cstm:personalization': null,
  'Hardware:cstm:service': null,
  'Hardware:cstm:15085': [
    'Axis',
    'Screws',
    'Clip',
    'Backspacer',
    'Pivot Collar',
  ],
  'Hardware:cstm:15080': [
    'Axis',
    'Screws',
    'Clip',
    'Backspacer',
    'Pivot Collar',
  ],
};

const getDrawerCategories = (tagName, drawerName) => {
  const key = `${drawerName}:${tagName}`;
  const category = categoryMap[key];
  return category;
};

export default getDrawerCategories;
